import { InfoFilledIcon } from '@calizahq/react-components-v2'
import { Link } from 'react-router-dom'

import { MemberListRow, UserListRow } from '@/types/User'

export const MembersListColumns = [
  {
    Header: 'Member',
    accessor: 'fullName',
    width: 75,
    Cell: function _Cell({ value }: any) {
      return (
        <div className="flex items-center justify-center">
          <div className="flex flex-col font-medium">
            <h3 className="font-bold">{value}</h3>
          </div>
        </div>
      )
    },
  },
  {
    Header: 'Email',
    accessor: 'email',
    width: 100,
  },
  {
    Header: 'Phone',
    accessor: 'phone',
    width: 50,
    canResize: false,
  },
  {
    accessor: 'id',
    width: 10,
    canResize: false,
    Cell: function _Cell({ value }: any) {
      return (
        <div className="ml-auto flex items-center justify-center" title="View Member">
          <Link to={`/members/${value}`}>
            <InfoFilledIcon className="ml-2 text-green-300" height={24} width={24} />
          </Link>
        </div>
      )
    },
  },
]

export function membersListMapping(members: UserListRow[]): MemberListRow[] {
  return members.map((member) => {
    return {
      roleName: UserRolesIdMapping[member.role],
      ...member,
    }
  })
}

const UserRolesIdMapping = {
  0: 'applicant',
  1: 'member',
  2: 'admin',
  3: 'host',
  4: 'guest',
  5: 'super_admin',
  6: 'partner',
  7: 'read_only_admin',
  8: 'company_owner',
  9: 'property_manager',
  10: 'affiliate',
  11: 'accounting_admin',
  12: 'designer',
  13: 'property_portal',
  14: 'employee_mover',
  15: 'painter',
  16: 'manual_scraper',
  17: 'fte_housekeeper',
  18: '3p_cleaner',
  19: 'professional_housing_coordinator',
}
